import { userRolesEnums } from '@/config';
import { convertArrayToNamedObjectsArray, getFormatedEstimatedProduction } from '@/services/helper.service.js';

class Specification {
  constructor(data) {
    data = data || {};

    this.color = data.currentColor || '#F3EFF0';
    this.name = data.specificationName;
    this.estProdKG = data.estProdKG;
    this.material = data.material;
    this.materialDetails = data.materialDetails;
    this.process = data.process;
    this.fineness = data.fineness;
    this.yarnCount = data.yarnCount;
    this.units = data.selectedUnits;
    this.machineGroups = data.selectedMachineGroups;
    this.isdtex = data.isdtex;
  }
}

class UpdateSpecification {
  constructor(data) {
    data = data || {};

    this.color = data.currentColor || '#F3EFF0';
    this.name = data.specificationName;
    this.estProdKG = data.estProdKG;
    this.material = data.material;
    this.materialDetails = data.materialDetails;
    this.process = data.process;
    this.fineness = data.fineness;
    this.yarnCount = data.yarnCount;
    this.specGuid = data.specGuid;
    this.isdtex = data.isdtex;
  }
}

class ImportSpecification {
  constructor(data, estimatedProductionFormat) {
    data = data || {};
    this.currentColor = (data.color == '#FFFFFF' ? '#784FB9' : data.color) || '#F3EFF0';
    this.specificationName = data.name;
    this.estProdKG = getFormatedEstimatedProduction(data.estProdKG, estimatedProductionFormat);
    this.material = data.material;
    this.materialDetails = data.materialDetails;
    this.process = data.process;
    this.fineness = data.fineness;
    this.yarnCount = data.yarnCount;
    this.specGuid = data.urlGuid;
    this.isdtex = data.isdtex;
  }
}

class SpecificationOptions {
  constructor(data) {
    data = data || {};

    this.material = data.material || 0;
    this.materialdetails = data.materialdetails || 0;
    this.process = data.process || 0;
    this.fineness = data.fineness || 0;
    this.yarnCount = data.yarnCount || 0;
  }
}

class UnitsWithSpecifications {
  constructor(data) {
    data = data || {};

    this.customerLogo = data.customerLogo || '';
    this.customerName = data.customerName || '';
    this.unassignedSpecifications = data.unassignedSpecifications || '';
    this.unitAddress = data.unitAddress || '';
    this.unitGuid = data.unitGuid || '';
    this.unitMachineGroups = data.unitMachineGroups || [];
    this.unitName = data.unitName || '';
    this.unitPicture = data.unitPicture || null;
    this.userRole = data.userRole || 0;

    this.userIsAdminOrOwner = [userRolesEnums.admin, userRolesEnums.owner].includes(data.userRole);
    this.userIsObserver = [userRolesEnums.observer].includes(data.userRole);
    this.userIsMaintenance = [userRolesEnums.maintenance].includes(data.userRole);
  }
}

class ShortUnitInfo {
  constructor(data) {
    data = data || {};
    this.unitName = data.unitName || '';
    this.customerName = data.customerName || '';
    this.unitGuid = data.unitGuid || '';
  }
}

class SortedSpecifications {
  constructor(data) {
    data = data || {};
    let numberOfUnassigned = 0;
    let specifications = {};

    data.unassignedSpecifications.forEach(specification => {
      // we used before white color, now we should lila insted of this
      if (specification !== null && specification.specColor == '#FFFFFF') {
        specification.specColor = '#784FB9';
      }
      specifications[specification.specGuid] = {};
      specifications[specification.specGuid] = { ...specification };
      specifications[specification.specGuid].total = 0;
    });
    data.unitMachineGroups.forEach(unit => {
      let specification = unit.machineGroupSpecification;
      if (specification !== null && specification.specColor == '#FFFFFF') {
        specification.specColor = '#784FB9';
      }
      if (unit.machineGroupSpecification) {
        if (specifications.hasOwnProperty(specification.specGuid)) {
          specifications[specification.specGuid].total = specifications[specification.specGuid].total + 1;
        } else {
          specifications[specification.specGuid] = {};
          specifications[specification.specGuid] = {
            ...specification
          };
          specifications[specification.specGuid].total = 1;
        }
      } else {
        numberOfUnassigned = numberOfUnassigned + 1;
      }
    });
    return {
      numberOfUnassigned,
      numberOfSpecifications: Object.keys(specifications).length,
      specifications
    };
  }
}

class AssignSpecification {
  constructor(data) {
    data = data || {};

    let machineGroupsGuids = [];
    let unitsGuids = [];
    if (Array.isArray(data.machineGroupGuid)) {
      machineGroupsGuids = data.machineGroupGuid;
    } else {
      machineGroupsGuids.push(data.machineGroupGuid);
    }
    unitsGuids.push(data.unitGuid);

    this.targetUnitGuids = unitsGuids;
    this.targetMachineGroupGuids = machineGroupsGuids;
    this.specGuid = data.specGuid;
  }
}

class UpdateAssignSpecification {
  constructor(data) {
    data = data || {};

    this.targetUnitGuids = data.selectedUnits;
    this.targetMachineGroupGuids = data.selectedMachineGroups;
    this.specGuid = data.specGuid;
  }
}

class UnassignSpecification {
  constructor(data) {
    data = data || {};
    this.machineGroupGuids = [];
    let initial = data.initialSelectedMachineGroups;
    let final = data.selectedMachineGroups;
    initial.forEach(group => {
      if (!final.includes(group)) {
        this.machineGroupGuids.push(group);
      }
    });
  }
}

export {
  Specification,
  UpdateSpecification,
  ImportSpecification,
  SpecificationOptions,
  UnitsWithSpecifications,
  AssignSpecification,
  UpdateAssignSpecification,
  SortedSpecifications,
  ShortUnitInfo,
  UnassignSpecification
};
